<template>
  <div class="experience">
    <div class="container-fluid">
      <h1>Portfolio</h1>
      <p>
        I carry out web development projects on a freelance basis. Below you can find a showcase of a range of website projects!
      </p>
      <p>
        Are you also interested in a high-quality, easy-to-manage, and sustainability-focused website? <a href="mailto:quan@vanderknokke.nl">Get in touch!</a>
      </p>
    </div>
    <div class="container-fluid">
      <h2>Web development portfolio</h2>
    </div>
    <PanelsList :panels="portfolioPanels" :sm="true" :containImage="true" />
  </div>
</template>

<script>
import PanelsList from "@/components/PanelsList";

export default {
  name: "Portfolio",
  components: {
    PanelsList
  },
  data() {
    return {
      portfolioPanels: [
        {
          title: "GreenDatabase",
          description: {
            image: "icon/greentu.png",
            icons: [
              {
                icon: "box-seam",
                title: "Main technologies",
                text: "Plain HTML, SCSS, TS, Sheets API"
              }
            ]
          },
          content: {
            text: "As part of my board year at GreenTU Delft, I developed this web portal to visualise data on sustainable education, research, and groups at the university. All content, as well as formatting settings, are retrieved from a spreadsheet using the Google Sheets API and visualised as a filterable and sortable list of cards. Also supports a special field type depicting SDGs.",
            image: "mockup/greendatabase.png",
            icons: [
              {
                icon: "calendar-check",
                title: "Date",
                text: "Summer 2023"
              },
              {
                icon: "box-seam",
                title: "Main technologies",
                text: "Plain HTML, SCSS, TS, Google Sheets API"
              }
            ],
            links: [
              {
                icon: "globe2",
                title: "Visit the GreenDatabase",
                url: "https://tudelft.nl/greentu/greendatabase"
              }
            ]
          }
        },
        {
          title: "StudioAdmin",
          description: {
            image: "icon/studioadmin.png",
            icons: [
              {
                icon: "box-seam",
                title: "Main technologies",
                text: "Umbraco 12, SCSS"
              }
            ]
          },
          content: {
            text: "A web portal used to register and keep track of participants of the Canidream studio. Administrators can use Umbraco to view and edit profiles, and participants are automatically sent a customised QR code, linked to this profile, they can use to identify themselves on accessing the studio.",
            image: "mockup/studioadmin.png",
            icons: [
              {
                icon: "calendar-check",
                title: "Date",
                text: "Summer 2023"
              },
              {
                icon: "box-seam",
                title: "Main technologies",
                text: "Umbraco 12, SCSS"
              }
            ]
          }
        },
        {
          title: "Delft Ontdekt",
          description: {
            image: "icon/delftontdekt.png",
            icons: [
              {
                icon: "box-seam",
                title: "Main technologies",
                text: "Umbraco 11, SCSS"
              }
            ]
          },
          content: {
            text: "A website that displays a calendar of events for the year commemorating the history of slavery in the city of Delft. Besides a public calendar and information pages, it has Google Forms integrations for event organisers to submit their events for approval and listing.",
            image: "mockup/delftontdekt.png",
            icons: [
              {
                icon: "calendar-check",
                title: "Date",
                text: "Spring 2023"
              },
              {
                icon: "box-seam",
                title: "Main technologies",
                text: "Umbraco 11, SCSS"
              }
            ],
            links: [
              {
                icon: "globe2",
                title: "Visit delftontdekt.nl",
                url: "https://delftontdekt.nl/"
              }
            ]
          }
        },
        {
          title: "Love Me True",
          description: {
            image: "icon/lovemetrue.png",
            icons: [
              {
                icon: "box-seam",
                title: "Main technologies",
                text: "Umbraco 10, Tailwind"
              }
            ]
          },
          content: {
            text: "A website for Love Me True, a relationship therapist service. A general-purpose information website with a clean design, based around a homepage with colour-coded sections and subtle animations.",
            image: "mockup/lovemetrue.png",
            icons: [
              {
                icon: "calendar-check",
                title: "Date",
                text: "Autumn 2022"
              },
              {
                icon: "box-seam",
                title: "Main technologies",
                text: "Umbraco 10, Tailwind"
              }
            ],
            links: [
              {
                icon: "globe2",
                title: "Visit lovemetrue.nl",
                url: "https://lovemetrue.nl/"
              }
            ]
          }
        },
        {
          title: "YourMic 2.0",
          description: {
            image: "icon/yourmic-dark.png",
            icons: [
              {
                icon: "box-seam",
                title: "Main technologies",
                text: "Umbraco 10, Bootstrap 5, SCSS"
              }
            ]
          },
          content: {
            text: "For the second round of the YourMic contest, its website was redeveloped based on Umbraco based on the organisation's need for easy content management. Also included various other styling and settings improvements, making the website suitable for reuse in future editons of YourMic.",
            image: "mockup/yourmic-v2.png",
            icons: [
              {
                icon: "calendar-check",
                title: "Date",
                text: "Spring 2022"
              },
              {
                icon: "box-seam",
                title: "Main technologies",
                text: "Umbraco 9, Bootstrap 5, SCSS"
              }
            ],
            links: [
              {
                icon: "globe2",
                title: "Visit yourmic.nl",
                url: "https://yourmic.nl/"
              }
            ]
          }
        },
        {
          title: "BASI Stempelkaart",
          description: {
            image: "icon/basi.png",
            icons: [
              {
                icon: "box-seam",
                title: "Main technologies",
                text: "Umbraco 10, Bootstrap 5, SCSS"
              }
            ]
          },
          content: {
            text: "A portal for BASI/MDT participants to collect stamps based on attendance of activities. Once logged in, participants can see their collected stamps, stamps that can still be collected, and the accumulated MDT hours in different activity categories shown as dynamic progress bars. Powered by the Umbraco membership system.",
            image: "mockup/stempelkaart.png",
            icons: [
              {
                icon: "calendar-check",
                title: "Date",
                text: "Spring 2022"
              },
              {
                icon: "box-seam",
                title: "Main technologies",
                text: "Umbraco 10, Bootstrap 5, SCSS"
              }
            ]
          }
        },
        {
          title: "IE Portal",
          description: {
            image: "icon/ieportal.png",
            icons: [
              {
                icon: "box-seam",
                title: "Main technologies",
                text: "Vue.js 3, Bootstrap 5, SCSS"
              }
            ]
          },
          content: {
            text: "A startpage website that links to websites relevant for students of Industrial Ecology. Started as a personal startpage, useful in a multi-university programme with multiple study guides, webmail sites and student portals. Made into a full website, being surprisingly well-received by fellow IE students.",
            image: "mockup/ieportal.png",
            icons: [
              {
                icon: "calendar-check",
                title: "Date",
                text: "Autumn 2021"
              },
              {
                icon: "box-seam",
                title: "Main technologies",
                text: "Vue.js 3, Bootstrap 5, SCSS"
              }
            ],
            links: [
              {
                icon: "globe2",
                title: "Visit ie.quan.cat",
                url: "https://ie.quan.cat/"
              }
            ]
          }
        },
        {
          title: "Keiryuji 2.0",
          description: {
            image: "icon/keiryuji.png",
            icons: [
              {
                icon: "box-seam",
                title: "Main technologies",
                text: "Umbraco 9, Bootstrap 5, SCSS"
              }
            ]
          },
          content: {
            text: "A new website for Keiryuji, a buddhist temple in the Pyrenees. This new site based on Umbraco 9 offers easy editing and various quality improvements over the previous site, including more professional layouts based on the Umbraco grid.",
            image: "mockup/keiryuji-v2.png",
            icons: [
              {
                icon: "calendar-check",
                title: "Date",
                text: "Summer 2021"
              },
              {
                icon: "box-seam",
                title: "Main technologies",
                text: "Umbraco 9, Bootstrap 5, SCSS"
              }
            ],
            links: [
              {
                icon: "globe2",
                title: "Visit www.keiryuji.org",
                url: "https://keiryuji.org/"
              }
            ]
          }
        },
        {
          title: "BASI",
          description: {
            image: "icon/basi.png",
            icons: [
              {
                icon: "box-seam",
                title: "Main technologies",
                text: "Umbraco 8, Bootstrap 5, SCSS"
              }
            ]
          },
          content: {
            text: "A website for BASI, a youth social work project by Canidream and partners. This website, which can be administered using Umbraco, allows visitors to obtain information about and sign up for the project.",
            image: "mockup/basi.png",
            icons: [
              {
                icon: "calendar-check",
                title: "Date",
                text: "Spring 2021"
              },
              {
                icon: "box-seam",
                title: "Main technologies",
                text: "Umbraco 8, Bootstrap 5, SCSS"
              }
            ],
            links: [
              {
                icon: "globe2",
                title: "Visit www.basi-mdt.nl",
                url: "https://basi-mdt.nl/"
              }
            ]
          }
        },
        {
          title: "Canidream",
          description: {
            image: "icon/canidream.png",
            icons: [
              {
                icon: "box-seam",
                title: "Main technologies",
                text: "Umbraco 8, Bootstrap 5, SCSS"
              }
            ]
          },
          content: {
            text: "A new website for Canidream, a social foundation in Delft. Using Umbraco, Canidream can easily administrate and keep up-to-date information on their project, testimonials, and partners.",
            image: "mockup/canidream.png",
            icons: [
              {
                icon: "calendar-check",
                title: "Date",
                text: "Spring 2021"
              },
              {
                icon: "box-seam",
                title: "Main technologies",
                text: "Umbraco 8, Bootstrap 5, SCSS"
              }
            ],
            links: [
              {
                icon: "globe2",
                title: "Visit www.canidream.nl",
                url: "https://canidream.nl/"
              }
            ]
          }
        },
        {
          title: "YourMic",
          description: {
            image: "icon/yourmic.png",
            icons: [
              {
                icon: "box-seam",
                title: "Main technologies",
                text: "Vue.js, Strapi, Bootstrap 5"
              }
            ]
          },
          content: {
            text: "This single-page webapp offers information on the Canidream YourMic music contest, as well as media file downloads for participants. Based on Vue.js/Nuxt.js and using Strapi as a separate API, data could be easily changed as the contest progressed.",
            image: "mockup/yourmic.jpg",
            icons: [
              {
                icon: "calendar-check",
                title: "Date",
                text: "Spring 2021"
              },
              {
                icon: "box-seam",
                title: "Main technologies",
                text: "Vue.js, Strapi, Bootstrap 5"
              }
            ],
            links: [
              {
                icon: "globe2",
                title: "Visit www.yourmic.nl",
                url: "https://yourmic.nl/"
              }
            ]
          }
        },
        {
          title: "Portfolio Site",
          description: {
            image: "icon/portfoliosite.png",
            icons: [
              {
                icon: "box-seam",
                title: "Main technologies",
                text: "Vue.js, Bootstrap 5, SCSS"
              }
            ]
          },
          content: {
            text: "The website you're currently visiting employs the Vue.js framework, as well as the new version of Bootstrap for the layout. It is responsive and, as is appropriate for 2020, a dark mode stylesheet which is used automatically when using a device preferring dark mode. And a nice CSS-based animation when opening its modals. Thanks for checking it out!",
            image: "mockup/portfoliosite.png",
            icons: [
              {
                icon: "calendar-check",
                title: "Date",
                text: "Summer 2020"
              },
              {
                icon: "box-seam",
                title: "Main technologies",
                text: "Vue.js, Bootstrap 5, SCSS"
              }
            ]
          }
        },
        {
          title: "Matcha Macha",
          description: {
            image: "icon/matchamacha.png",
            icons: [
              {
                icon: "box-seam",
                title: "Main technologies",
                text: "Umbraco 8, Bootstrap 4, SCSS"
              }
            ]
          },
          content: {
            text: "This lunchroom website features a clean design with quick contact information, an image carousel with custom Ken Burns-style transitions, and a description. It also includes a simple contact form, which appears using a flip animation. All content can be easily managed using the Umbraco backoffice.",
            image: "mockup/matchamacha.png",
            icons: [
              {
                icon: "calendar-check",
                title: "Date",
                text: "Spring 2020"
              },
              {
                icon: "box-seam",
                title: "Main technologies",
                text: "Umbraco 8, Bootstrap 4, SCSS"
              }
            ],
            links: [
              {
                icon: "globe2",
                title: "Visit www.matchamacha.nl",
                url: "https://matchamacha.nl/"
              }
            ]
          }
        },
        {
          title: "NOBIS",
          description: {
            image: "icon/nobis.png",
            icons: [
              {
                icon: "box-seam",
                title: "Main technologies",
                text: "Plain HTML and SCSS"
              }
            ]
          },
          content: {
            text: "I developed this website to promote NOBIS and our social project, Fingerprint Art. It has a light yet colourful design fitting in with the branding of our presentations and documents, made easy to apply using SCSS mixins and loops. As it is a simple site, it has no CMS, but it does have an Ajax/PHP contact form. It is no longer available, having been integrated into the website of the Canidream foundation.",
            image: "mockup/nobis.png",
            icons: [
              {
                icon: "calendar-check",
                title: "Date",
                text: "Spring 2019"
              },
              {
                icon: "box-seam",
                title: "Main technologies",
                text: "WordPress"
              }
            ],
            links: [
            ]
          }
        },
        {
          title: "La Forja",
          description: {
            image: "icon/laforja.png",
            icons: [
              {
                icon: "box-seam",
                title: "Main technologies",
                text: "Umbraco 7, Bootstrap 4, SCSS"
              }
            ]
          },
          content: {
            text: "The website for La Forja, youth organisation based in Catalonia, has a custom design according to the organisation's brand guidelines. It is responsive, has an embedded Twitter feed, as well as a blog-style list of Publications and a customisable carousel image. The Umbraco backoffice, from which the content can be managed, has a custom translation into Catalan. It is no longer available online.",
            image: "mockup/laforja.png",
            icons: [
              {
                icon: "calendar-check",
                title: "Date",
                text: "Summer 2018"
              },
              {
                icon: "box-seam",
                title: "Main technologies",
                text: "Umbraco 7, Bootstrap 4, SCSS"
              }
            ],
            links: []
          }
        },
        {
          title: "Kind Centraal",
          description: {
            image: "icon/kc.png",
            icons: [
              {
                icon: "box-seam",
                title: "Main technologies",
                text: "WordPress"
              }
            ]
          },
          content: {
            text: "This WordPress-based website includes a modernised and responsive design, while remaining in the same style as the previous Kind Centraal website.",
            image: "mockup/kc.png",
            icons: [
              {
                icon: "calendar-check",
                title: "Date",
                text: "Summer 2017"
              },
              {
                icon: "box-seam",
                title: "Main technologies",
                text: "WordPress"
              }
            ],
            links: [
              {
                icon: "globe2",
                title: "Visit www.kindcentraal.nl",
                url: "http://kindcentraal.nl/"
              }
            ]
          }
        },
        {
          title: "Keiryuji",
          description: {
            image: "icon/keiryuji.png",
            icons: [
              {
                icon: "box-seam",
                title: "Main technologies",
                text: "WordPress"
              }
            ]
          },
          content: {
            text: "This website for Keiryuji, a buddhist temple in the Pyrenees, is based on WordPress and has a design suited for the content of the page, as well as a full-width banner image on every page. It is no longer available, having been replaced with a brand-new experience based on Umbraco 9.",
            image: "mockup/keiryuji.png",
            icons: [
              {
                icon: "calendar-check",
                title: "Date",
                text: "Summer 2015"
              },
              {
                icon: "box-seam",
                title: "Main technologies",
                text: "WordPress"
              }
            ],
            links: []
          }
        }
      ]
    };
  }
};
</script>
